import { TFunction } from "i18next";

export const getCategories = (t: TFunction): string[] => [
    t('Categories.fashion'),
    t('Categories.technology'),
    t('Categories.beauty'),
    t('Categories.home'),
    t('Categories.health'),
    t('Categories.food'),
    t('Categories.art'),
    t('Categories.automotive'),
    t('Categories.toys'),
    t('Categories.books'),
    t('Categories.entertainment'),
    t('Categories.petSupplies'),
    t('Categories.sports'),
    t('Categories.kids'),
    t('Categories.luxury')
]